import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { BehaviourService } from 'src/app/shared/services/behaviour.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ConfigService } from 'src/app/shared/services/config.service';
import { DexieDbService } from 'src/app/shared/services/dexie-db.service';
import {
  configurationIdMapForProductCode,
  configurationIdMapForProductName,
} from 'src/app/utils/constants/constant';
import { createConfigArray } from 'src/app/utils/default-configs/configuration';
import { DGPackage } from 'src/app/utils/constants/strings';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-shipment-info',
  templateUrl: './shipment-info.component.html',
  styleUrls: ['./shipment-info.component.scss'],
})
export class ShipmentInfoComponent implements OnChanges {
  @Input() shipmentForm: FormGroup;
  @Input() currencyValues;
  @Input() DGContentIDValues;
  @Input() DGPackageData;
  @Input() customDescriptions;
  @Input() DGContentFromConfig;
  @Input() shipmentDeclaredValue;
  @Input() productNameValues;
  @Input() customsDeclarableValue;

  dgContentIds = [];
  selectedPreDGContentIds: string[] = [];
  selectedDescription = [];
  flags = ['Y', 'N'];
  misMatchInCurrency: boolean;
  selectedDGTabIndex: any = 0;
  isValidShipmentID: boolean = true;
  @Output() validateMod7 = new EventEmitter<boolean>();
  enumDGPackage = DGPackage;
  selectedDGPackage: any = [];
  dgPackageDryIcelValue: any = [];
  dgPackageBiologicalValue: any = [];

  constructor(private behaviourService: BehaviourService, private dexieDbService: DexieDbService) {}

  ngOnInit() {
    this.isLineItemCurrencyChanged();
    this.validateShipmentID();
    this.shipmentForm.valueChanges.subscribe(formValue => {
      if (formValue?.DGPackageData && formValue?.DGPackageData.length) {
        if (!this.dgPackageDryIcelValue.length) {
          this.dgPackageDryIcelValue =
            formValue.DGPackageData.filter(
              d => d.contentId == this.enumDGPackage.DryIce.toString()
            ) || [];
        }

        if (!this.dgPackageBiologicalValue.length) {
          this.dgPackageBiologicalValue =
            formValue.DGPackageData.filter(
              d => d.contentId == this.enumDGPackage.BiologicalSubstance.toString()
            ) || [];
        }
      }

      //initialize the tab selection for dryIce and Biological substance
      if (formValue?.DGContentID && formValue?.DGContentID.length) {
        const workflow = sessionStorage.getItem('loose-bbx');
        this.dgContentIds = this.DGContentIDValues.map(e => {
          if (
            workflow === 'Yes' &&
            (e.dg_content_id == this.enumDGPackage.DryIce.toString() ||
              e.dg_content_id == this.enumDGPackage.BiologicalSubstance.toString())
          ) {
          } else {
            if (this.DGContentFromConfig?.includes(e.dg_content_id)) return e;
          }
        }).filter(e => e?.code);
        this.selectedDGPackage = this.getDGPackages(formValue.DGContentID);
      }
    });
  }

  isLineItemCurrencyChanged() {
    this.shipmentForm.controls?.['lineItemUnitPriceCurrency']?.valueChanges.subscribe(data => {
      this.behaviourService.sendEvent(data);
    });

    this.behaviourService.currentMessage.subscribe((data: any) => {
      if (
        this.shipmentForm?.value?.shipmentDeclaredValueCurrency &&
        data?.lineItems &&
        data?.lineItems?.length > 0 &&
        data?.lineItems[0]?.lineItemUnitPriceCurrency
      ) {
        if (
          this.shipmentForm?.value?.shipmentDeclaredValueCurrency !==
          data?.lineItems[0]?.lineItemUnitPriceCurrency
        ) {
          this.misMatchInCurrency = true;
        } else {
          this.misMatchInCurrency = false;
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'DGContentIDValues':
            this.DGContentIDValues = changes[propName].currentValue;
            break;
          case 'DGContentFromConfig':
            this.DGContentFromConfig = changes[propName].currentValue;
            break;
          case 'customDescriptions':
            this.customDescriptions = changes[propName].currentValue;
            break;
          case 'shipmentDeclaredValue':
            if (changes[propName].currentValue) {
              this.shipmentForm.patchValue({
                shipmentDeclaredValue: changes[propName].currentValue,
              });
            }
        }
      }
    }

    const workflow = sessionStorage.getItem('loose-bbx');
    if (this.DGContentIDValues?.length) {
      this.dgContentIds = this.DGContentIDValues.map(e => {
        if (
          workflow === 'Yes' &&
          (e.dg_content_id == this.enumDGPackage.DryIce.toString() ||
            e.dg_content_id == this.enumDGPackage.BiologicalSubstance.toString())
        ) {
        } else {
          if (this.DGContentFromConfig?.includes(e.dg_content_id)) return e;
        }
      }).filter(e => e?.code);

      if (workflow === 'No') {
        this.dgContentIds = this.dgContentIds.filter(function (arrayObj) {
          return arrayObj.name !== 'UN2807 Magnetized Material';
        });
      }
    }
  }

  selected(event) {
    this.selectedPreDGContentIds = event?.value;
  }

  get contentID() {
    return (
      this.shipmentForm.get('DGContentID').value?.includes('HU5') ||
      this.shipmentForm.get('DGContentID').value?.includes('E01')
    );
  }

  dgSelected(v) {
    return this.shipmentForm.get('DGContentID').value?.includes(v.toString());
  }

  dgPackageDryIcelValueChange(e) {
    let dgCleanData = e?.filter(dg => dg.packageNo > 0 && dg.packageWeight > 0);
    let dgValue =
      this.shipmentForm
        .get('DGPackageData')
        .value?.filter(d => d.contentId != this.enumDGPackage.DryIce.toString()) || [];

    const mapData = [...dgValue, ...dgCleanData].map(d => {
      return {
        contentId: d.contentId,
        packageNo: d.packageNo,
        packageWeight: d.packageWeight,
      };
    });
    this.shipmentForm.markAsDirty();
    this.shipmentForm.patchValue({ DGPackageData: mapData });
  }

  dgPackageBiologicalValueChange(e) {
    let dgCleanData = e?.filter(dg => dg.packageNo > 0);
    let dgValue =
      this.shipmentForm
        .get('DGPackageData')
        .value?.filter(d => d.contentId != this.enumDGPackage.BiologicalSubstance.toString()) || [];

    const mapData = [...dgValue, ...dgCleanData].map(d => {
      return {
        contentId: d.contentId,
        packageNo: d.packageNo,
        packageWeight: d.packageWeight,
      };
    });
    this.shipmentForm.markAsDirty();
    this.shipmentForm.patchValue({ DGPackageData: mapData });
  }

  getDGPackages(e: any) {
    let ff = e.filter(
      f =>
        f == this.enumDGPackage.BiologicalSubstance.toString() ||
        f == this.enumDGPackage.DryIce.toString()
    );

    let dd = ff.map(f => {
      return this.dgContentIds.filter(d => d.dg_content_id == f.toString())[0];
    });

    return dd;
  }

  selectContentID(e: any) {
    this.shipmentForm.markAsDirty();
    if (!this.contentID) {
      this.shipmentForm.controls.DGCustomDescription.setValidators(null);
      this.shipmentForm.controls.DGCustomDescription.setErrors(null);
      this.shipmentForm.patchValue({ DGCustomDescription: [] });
    } else {
      this.shipmentForm.controls.DGCustomDescription.setValidators([Validators.required]);
    }

    this.selectedDGPackage = this.getDGPackages(e.value);

    if (
      !this.selectedDGPackage.filter(
        d => d.dg_content_id == this.enumDGPackage.BiologicalSubstance.toString()
      ).length
    )
      this.dgPackageBiologicalValue = [];

    if (
      !this.selectedDGPackage.filter(d => d.dg_content_id == this.enumDGPackage.DryIce.toString())
        .length
    )
      this.dgPackageDryIcelValue = [];

    this.shipmentForm.patchValue({
      DGPackageData: [...this.dgPackageBiologicalValue, ...this.dgPackageDryIcelValue],
    });
  }
  ngOnDestroy(): void {
    this.behaviourService.sendEvent(null);
  }

  onShipCurrencyChange(event) {
    if (this.shipmentForm?.value?.invoiceDetails?.lineItems[0]?.lineItemUnitPriceCurrency) {
      if (
        this.shipmentForm?.value?.invoiceDetails?.lineItems[0]?.lineItemUnitPriceCurrency !== event
      ) {
        this.misMatchInCurrency = true;
      } else {
        this.misMatchInCurrency = false;
      }
      this.behaviourService.sendEvent(this.misMatchInCurrency);
    }
  }

  validateShipmentID() {
    this.shipmentForm
      .get('shipmentID')
      .valueChanges.pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe(shipmentID => {
        if (/^\d{10}$/.test(shipmentID)) {
          // Extract first 9 digits and last digit
          const firstNDigits = shipmentID.slice(0, 9);
          const checksumDigit = parseInt(shipmentID.charAt(9), 10);

          // Check if base number is in the valid range
          const baseValue = parseInt(firstNDigits, 10);
          if (baseValue < 100000000 || baseValue > 999999999) {
            this.validateMod7.emit(false);
          }

          // Calculate MOD 7 checksum
          const calculatedChecksum = baseValue % 7;

          // Compare calculated checksum with last digit
          if (calculatedChecksum === checksumDigit) {
            this.isValidShipmentID = true;
            this.validateMod7.emit(true);
          } else {
            this.isValidShipmentID = false;
            this.validateMod7.emit(false);
          }
        }
      });
  }

  selectProductName(event) {
    const selectedProductName = event.value;
    let fetchAccoutConfig;
    if (selectedProductName === 'B' || selectedProductName === 'A') {
      fetchAccoutConfig = configurationIdMapForProductCode.BABY_ACCOUNT_NUMBERS;
    } else {
      fetchAccoutConfig = configurationIdMapForProductCode.INDIVIDUAL_SHIP_ACCOUNT_NUMBERS;
    }
    this.dexieDbService.getConfig(fetchAccoutConfig).then(response => {
      if (response?.data) this.patchAccoutValue(response?.data);
    });
    this.behaviourService.sendEvent({ type: 'productCode', value: selectedProductName });
  }

  patchAccoutValue(dbAccountData) {
    const accoundata: any = {};
    dbAccountData.forEach(({ name, number }) => {
      if (['shipperAccountNumber', 'payerAccountNumber', 'dutyAccountNumber'].includes(name)) {
        accoundata[name] = number;
      }
    });
    this.shipmentForm.get('shipperAccountNumber')?.reset();
    this.shipmentForm.get('payerAccountNumber')?.reset();
    this.shipmentForm.get('dutyAccountNumber')?.reset();
    this.shipmentForm.patchValue(accoundata);
  }
}
